import React, {FC} from "react"
import PropTypes from "prop-types"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"

interface Props {
  ctaType: "goToSavings" | "goToPerks"
}

const Cta: FC<Props> = ({ctaType}, {apps}) => {
  switch (ctaType) {
    case "goToSavings":
      return (
        <ButtonRouterLink app={apps.MY_SAVINGS} to="/" small>
          <FormattedMessage id="platform.mySavings.cta.goToSavings.copy" />
        </ButtonRouterLink>
      )
    default:
      return (
        <ButtonRouterLink app={apps.PERKS} to="/" primary small>
          <FormattedMessage id="platform.mySavings.cta.goToPerks.copy" />
        </ButtonRouterLink>
      )
  }
}

Cta.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default Cta
